@if(props.label) {
    <div class="p-field">
        <label>{{props.label}}@if(props.required) { <span>*</span>}</label>
        <div class="time-input-wrapper">
            <p-inputmask
                [(ngModel)]="timeValue"
                (ngModelChange)="onTimeChange($event)"
                (onFocus)="onFocus()"
                (onBlur)="onBlur()"
                (onComplete)="onComplete()"
                mask="99:99"
                [placeholder]="hasFocus ? '00:00' : ''"
                [autoClear]="false"
                slotChar="0"
                [fluid]="true"
                [styleClass]="(isInvalid || showError) ? 'ng-invalid ng-dirty' : ''" />
            <span class="time-suffix" [class.suffix-error]="showError || isInvalid">hs</span>
        </div>
        @if(showError || isInvalid) {
            <small class="p-error">
                @if(isInvalid) {
                    Hora inválida (00:00 - 23:59)
                } @else {
                    <formly-validation-message [field]="field" />
                }
            </small>
        }
    </div>
} @else {
    <div class="time-input-wrapper">
        <p-inputmask
            [(ngModel)]="timeValue"
            (ngModelChange)="onTimeChange($event)"
            (onFocus)="onFocus()"
            (onBlur)="onBlur()"
            (onComplete)="onComplete()"
            mask="99:99"
            [placeholder]="hasFocus ? '00:00' : ''"
            [autoClear]="false"
            slotChar="0"
            [fluid]="true"
            [styleClass]="(isInvalid || showError) ? 'ng-invalid ng-dirty' : ''" />
        <span class="time-suffix" [class.suffix-error]="showError || isInvalid">hs</span>
    </div>
    @if(showError || isInvalid) {
        <small class="p-error">
            @if(isInvalid) {
                Hora inválida (00:00 - 23:59)
            } @else {
                <formly-validation-message [field]="field" />
            }
        </small>
    }
}
